import React from "react"
import './css/createhotel.css';
import './css/App.css';
import { getciaw } from "../dbconnector/connector";
import { setErrorMessage } from "../tools/errorhandling";
import { useState } from 'react';
import { useEffect } from 'react';
import hotelcss from './css/hotelhotellist.module.css';
import CiawResponse from '../customNodes/ciawResponse';
import { BiShowAlt } from 'react-icons/bi';
import { Navigate } from "react-router-dom";


const Ciaw = (props) => {

    const [ciaw, setCiaw] = useState([]);
    const [array, setArray] = useState([]);
    const [ciawresponse, setciawresponse] = useState([]);
    const t = props.translation


    useEffect(() => {
        const response = getciaw(Date.now())
        response.then(res => {
            createciawlist(res);
            setCiaw(res)
        });
    }, []);

    const handleCancel = () => {
        document.getElementById("ciawresponseDetails").style.display = "none"
        document.getElementById("coverAll").style.display = "none"
    }

    const showdetailerror = (id) => {
        setciawresponse(JSON.parse(document.getElementById("response_" + id).innerText))
        document.getElementById("coverAll").style.display = "block"
        document.getElementById("ciawresponseDetails").style.display = "block"

    }

    const createciawlist = (ciaw) => {
        setArray([])
        ciaw.forEach((item, index) => {
            const obj = JSON.parse(item.response)[0];
            const payload = JSON.parse(item.message);
            if (obj.createdPresenceRegistration) {
                if (obj.createdPresenceRegistration === null) {
                    console.log(payload.items[0])
                    setArray(pre => [...pre, <div className={hotelcss.ciawlinkError} >
                        <p className="overflow">{t("failed")}</p>
                        <p className="overflow">{payload.items[0].type}</p>
                        <p className="overflow">{new Date(item.senddate).toLocaleDateString()} {new Date(item.senddate).toLocaleTimeString()}</p>
                        <p className="overflow">ssin: {payload.items[0].ssin}</p>
                        <p className={hotelcss.overflowresponse}>{obj.notCreatedPresenceRegistration.errorList[0].errorDescription}</p>
                    </div>]
                    )
                } else {
                    setArray(pre => [...pre, <div className={index % 2 === 0 ? hotelcss.ciawlinkVarient1 : hotelcss.ciawlinkVarient2} >
                        <p className="overflow">{t("success")}</p>
                        <p className="overflow">{obj.createdPresenceRegistration.type}</p>
                        <p className="overflow">{new Date(item.senddate).toLocaleDateString()} {new Date(item.senddate).toLocaleTimeString()}</p>
                        <p className="overflow">{obj.createdPresenceRegistration.worker.givenName} {obj.createdPresenceRegistration.worker.familyName}</p>
                        <div className="overflow" id={item.id} onClick={() => showdetailerror(item.id)}><BiShowAlt className='ciawdetailsicon'></BiShowAlt><div id={"response_" + item.id} className="hiddendiv">{item.response}</div></div>
                    </div>]
                    )
                }
            } else {
                setArray(pre => [...pre, <div className={hotelcss.ciawlinkError} >
                    <p className="overflow">{t("failed")}</p>
                    <p className="overflow">{ }</p>
                    <p className="overflow">{new Date(item.senddate).toLocaleDateString()} {new Date(item.senddate).toLocaleTimeString()}</p>
                    <p className="overflow">{item.fullname}</p>
                    <div className={hotelcss.overflowresponse} id={item.id} ><BiShowAlt></BiShowAlt><div id={"response_" + item.id} className="hiddendiv">{item.response}</div></div>
                </div>]
                )
            }
        })
    }

    const filterlist = () => {
        const date = document.getElementById("dateinput").value;
        console.log(date)
        if (date === "") {
            setErrorMessage(t("error_FillInDate"))
            return;
        }
        const response = getciaw(date)
        response.then(res => {
            console.log(res)
            setCiaw(res)
            createciawlist(res);
        })
    }


    return (
        <>
            <div id="main">
                <div id="coverAll" className="subscreen">
                    <CiawResponse
                        rights={props.rights}
                        t={props.translation}
                        isDisabled={false}
                        data={{
                            ciawresponse: ciawresponse
                        }}
                        events={{
                            handleCancel: handleCancel,
                            // handleOnchange: handleOnchange,
                            // handleChangecheckbox: handleChangecheckbox,
                            // showAssignedCleaningTasks: showAssignedCleaningTasks,
                            // handlDeleteAssignment: handlDeleteAssignment,
                            // handlEditAssignment: handlEditAssignment,
                            // handlUpdateAssignment: handlUpdateAssignment,
                            // handlCreateAssignment: handlCreateAssignment,

                        }}
                    />
                </div>
                <header>
                    <div id="errordiv" className='error'></div>
                </header>
                <div id="filters" className="form" >
                    <label className='formtitleContentBox'>{t("filterinstellingen")}</label>
                    <br></br>
                    <div className="contentbox">

                        <div className="formElement">
                            <label className='labelcolor'>
                                {t("day")}:
                            </label>
                            <input id="dateinput" type='Date'></input>
                        </div>
                        <div className="formElement">
                            <label className='labelcolor' />
                            <button className='buttoncontainer filterButton' type='button' id="filterbutton" onClick={filterlist}> {t("filter")}</button>
                        </div>
                    </div>
                    <br></br>
                </div>
                <div id="headertable" className={hotelcss.ciawtableheader}><p id="status">status</p><p id="type">type</p><p id="senddate">senddate</p><p id="Name">Name</p><p id="Response">{t("response")}</p></div>
                <div id='ciawlist' className='list'>
                    <div id="array" >{array}</div>
                </div>

            </div>
        </>
    )
}

export default Ciaw